/**
 * List of supported facet types
 */
export enum SearchFacetType {
  CHECKBOX, DATE_RANGE, TOGGLE, RANGE, DROPDOWN_MULTI_SELECT
}
